import Service from './blocks/Service'
import ServiceList from './blocks/ServiceList'

export const dynamicBlocks = {
  service: Service,
  serviceList: ServiceList
}
